


























import { Component, Mixins } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class HomeView extends Mixins() {
  bottonWidth = '220px'
  created() {
    this.$store.state.showAppbar = false
    this.$store.state.filters = {}
    /*  this.getCowTestOnline() */
  }

  mounted() {
    this.$store.state.showAppbar = false
  }

  goTo(farm: any) {
    this.$store.state.selectedFarmId = farm.id
    this.$router.push(`/cows`)
  }
}
